import { render, staticRenderFns } from "./data-center-selection.vue?vue&type=template&id=937f1bbe&"
import script from "./data-center-selection.vue?vue&type=script&lang=tsx&"
export * from "./data-center-selection.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports